// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchCell-cls1_Re5","cls2":"SearchCell-cls2_NRm SearchCell-cls1_Re5"};